import React, { useState, useEffect } from 'react';
import { ContentData } from '../data/contentData';

interface HomePageProps {
  content: ContentData;
}

const HomePage: React.FC<HomePageProps> = ({ content }) => {
  // State for current slide
  const [currentSlide, setCurrentSlide] = useState(0);

  // News ticker data
  const newsTicker = [
    {
      id: 1,
      type: 'জরুরী',
      text: 'নবম শ্রেণীর রেজিষ্ট্রেশন চলমান - ভর্তি প্রক্রিয়া শুরু হয়েছে। দ্রুত আবেদন করুন।',
      priority: 'high'
    },
    {
      id: 2,
      type: 'নোটিশ',
      text: 'আইডি কার্ড ও স্কুল ড্রেস বাধ্যতামূলক - সকল শিক্ষার্থীদের জন্য আইডি কার্ড ও স্কুল ড্রেস পরিধান বাধ্যতামূলক।',
      priority: 'medium'
    },
    {
      id: 3,
      type: 'তথ্য',
      text: 'অনলাইন একাউন্ট খোলার নির্দেশ - সকল শিক্ষার্থী ও শিক্ষকদের জন্য অনলাইন একাউন্ট খোলা বাধ্যতামূলক।',
      priority: 'info'
    },
    {
      id: 4,
      type: 'পরীক্ষা',
      text: 'বার্ষিক পরীক্ষার সময়সূচী - বার্ষিক পরীক্ষার সময়সূচী প্রকাশিত হয়েছে। নোটিশ বোর্ডে দেখুন।',
      priority: 'exam'
    },
    {
      id: 5,
      type: 'ক্রীড়া',
      text: 'বার্ষিক ক্রীড়া দিবস ২০২৫ - ১৫ ডিসেম্বর, ২০২৫ তারিখে বার্ষিক ক্রীড়া দিবস উদযাপিত হবে।',
      priority: 'sports'
    },
    {
      id: 6,
      type: 'বিজ্ঞান',
      text: 'বিজ্ঞান মেলা ২০২৫ - ২০ নভেম্বর, ২০২৫ তারিখে বিজ্ঞান মেলা অনুষ্ঠিত হবে। সকল শিক্ষার্থী অংশগ্রহণ করবে।',
      priority: 'science'
    },
    {
      id: 7,
      type: 'সাংস্কৃতিক',
      text: 'স্বাধীনতা দিবস উদযাপন - ২৬ মার্চ, ২০২৫ তারিখে স্বাধীনতা দিবস উদযাপিত হবে। বিশেষ অনুষ্ঠানের আয়োজন করা হয়েছে।',
      priority: 'cultural'
    }
  ];

  // State for news ticker
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  const [isNewsPaused, setIsNewsPaused] = useState(false);

  // State for college info section
  const [selectedInfo, setSelectedInfo] = useState('history');

  // College information data
  const collegeInfo: Record<string, {
    title: string;
    content: string;
    additionalInfo: Array<{
      type: string;
      content: string;
      color: string;
      hasButton?: boolean;
    }>;
  }> = {
    history: {
      title: '🏫 কলেজের ইতিহাস',
      content: 'আমাদের কলেজ প্রতিষ্ঠিত হয়েছিল ১৯৬৭ সালে, একটি ছোট পরিসরে। তখন মাত্র ২০ জন শিক্ষার্থী এবং ২ জন শিক্ষক নিয়ে যাত্রা শুরু হয়। আজ এটি একটি পূর্ণাঙ্গ শিক্ষা প্রতিষ্ঠান হিসেবে গড়ে উঠেছে যেখানে শতাধিক শিক্ষার্থী এবং অভিজ্ঞ শিক্ষকবৃন্দ রয়েছেন। কলেজটি শুধু পড়াশোনার জায়গা নয়, বরং একটি আদর্শ সমাজ গঠনের কারখানা হিসেবেও বিবেচিত হয়। শিক্ষার্থীদের নৈতিক শিক্ষা, শৃঙ্খলা এবং নেতৃত্ব গঠনের জন্য নিয়মিত বিভিন্ন কার্যক্রম পরিচালিত হয়।',
      additionalInfo: [
        {
          type: 'এমপিও',
          content: 'MPO হয়েছে ১৯৮৫ সালে। পাঠদানের অনুমতি ০১/০৯/১৯৭৪ মাধ্যমিক পর্যন্ত।',
          color: 'yellow'
        },
        {
          type: 'পাঠ দানের অনুমতি',
          content: 'পাঠ দানের অনুমতি পত্র ডাউনলোড করতে এই লিঙ্কে ক্লিক করুন।',
          color: 'blue',
          hasButton: true
        }
      ]
    },
    classes: {
      title: '📚 অনুমোদিত ক্লাসসমূহ',
      content: 'আমাদের বিদ্যালয়ে মাধ্যমিক স্তর পর্যন্ত শিক্ষা প্রদান করা হয়। বর্তমানে নিম্নলিখিত ক্লাসসমূহে পাঠদান চলছে:',
      additionalInfo: [
        {
          type: 'ষষ্ঠ শ্রেণী',
          content: '৬ষ্ঠ শ্রেণীতে বর্তমানে ১২০ জন শিক্ষার্থী অধ্যয়নরত।',
          color: 'blue'
        },
        {
          type: 'সপ্তম শ্রেণী',
          content: '৭ম শ্রেণীতে বর্তমানে ১১৫ জন শিক্ষার্থী অধ্যয়নরত।',
          color: 'green'
        },
        {
          type: 'অষ্টম শ্রেণী',
          content: '৮ম শ্রেণীতে বর্তমানে ১১০ জন শিক্ষার্থী অধ্যয়নরত।',
          color: 'purple'
        },
        {
          type: 'নবম শ্রেণী',
          content: '৯ম শ্রেণীতে বর্তমানে ১০৫ জন শিক্ষার্থী অধ্যয়নরত।',
          color: 'orange'
        },
        {
          type: 'দশম শ্রেণী',
          content: '১০ম শ্রেণীতে বর্তমানে ১০০ জন শিক্ষার্থী অধ্যয়নরত।',
          color: 'red'
        }
      ]
    },
    students: {
      title: '🎯 শিক্ষার্থীদের তথ্য',
      content: 'আমাদের বিদ্যালয়ে বর্তমানে মোট ৫৫০ জন শিক্ষার্থী অধ্যয়নরত। প্রতিটি শ্রেণীতে গড়ে ১১০ জন শিক্ষার্থী রয়েছে।',
      additionalInfo: [
        {
          type: 'মোট শিক্ষার্থী',
          content: '৫৫০ জন',
          color: 'blue'
        },
        {
          type: 'ছাত্র',
          content: '২৮০ জন',
          color: 'green'
        },
        {
          type: 'ছাত্রী',
          content: '২৭০ জন',
          color: 'pink'
        },
        {
          type: 'উপস্থিতি হার',
          content: '৯৫%',
          color: 'purple'
        }
      ]
    },
    idcard: {
      title: '🆔 আইডি কার্ড প্রিন্ট',
      content: 'আমাদের বিদ্যালয়ের সকল শিক্ষার্থীদের জন্য আইডি কার্ড বাধ্যতামূলক। আইডি কার্ডে শিক্ষার্থীর নাম, শ্রেণী, রোল নম্বর এবং ছবি থাকবে।',
      additionalInfo: [
        {
          type: 'আইডি কার্ড ফি',
          content: '৫০ টাকা',
          color: 'blue'
        },
        {
          type: 'প্রক্রিয়াকরণ সময়',
          content: '৩-৫ কর্মদিবস',
          color: 'green'
        },
        {
          type: 'প্রয়োজনীয় কাগজপত্র',
          content: 'ছবি, জন্ম নিবন্ধন সনদ',
          color: 'orange'
        }
      ]
    },
    results: {
      title: '🌟 এস.এস.সি. ফলাফল',
      content: 'আমাদের বিদ্যালয়ের এস.এস.সি. পরীক্ষার ফলাফল নিয়মিতভাবে প্রকাশিত হয়। শিক্ষার্থীরা অনলাইনে ফলাফল দেখতে পারবে।',
      additionalInfo: [
        {
          type: '২০২৪ ফলাফল',
          content: 'পাশের হার: ৯৮%',
          color: 'green'
        },
        {
          type: '২০২৩ ফলাফল',
          content: 'পাশের হার: ৯৬%',
          color: 'blue'
        },
        {
          type: '২০২২ ফলাফল',
          content: 'পাশের হার: ৯৫%',
          color: 'purple'
        }
      ]
    },
    principal: {
      title: '🗨️ প্রতিষ্ঠান প্রধানের বাণী',
      content: 'প্রিয় শিক্ষার্থী ও অভিভাবকবৃন্দ, আমাদের বিদ্যালয়ের লক্ষ্য হল শিক্ষার্থীদের সর্বাঙ্গীণ বিকাশ সাধন। আমরা চাই প্রতিটি শিক্ষার্থী যেন জ্ঞান, দক্ষতা এবং নৈতিক মূল্যবোধ নিয়ে সমাজে প্রতিষ্ঠিত হয়।',
      additionalInfo: [
        {
          type: 'প্রধান শিক্ষক',
          content: 'মোঃ হাসিবুল হাসান',
          color: 'blue'
        },
        {
          type: 'অভিজ্ঞতা',
          content: '১৫ বছর',
          color: 'green'
        },
        {
          type: 'যোগাযোগ',
          content: '০১৭১২-৩৪৫৬৭৮',
          color: 'purple'
        }
      ]
    }
  };

  // Slider images array - using the actual image names you added
  const sliderImages = [
    {
      id: 1,
      src: '/images/slider/1.jpg',
      alt: 'School Image 1',
      title: 'আমাদের বিদ্যালয়ের সেরা শিক্ষা',
      subtitle: 'উচ্চ মানের শিক্ষা ও নৈতিক মূল্যবোধের বিকাশ'
    },
    {
      id: 2,
      src: '/images/slider/2.jpg',
      alt: 'School Image 2',
      title: 'শিক্ষার্থীদের উন্নত শিক্ষা',
      subtitle: 'আধুনিক প্রযুক্তি ও ঐতিহ্যগত মূল্যবোধের সমন্বয়'
    },
    {
      id: 3,
      src: '/images/slider/3.jpg',
      alt: 'School Image 3',
      title: 'বিভিন্ন কার্যক্রম',
      subtitle: 'শিক্ষামূলক ও সাংস্কৃতিক কর্মকাণ্ডে অংশগ্রহণ'
    },
    {
      id: 4,
      src: '/images/slider/4.jpg',
      alt: 'School Image 4',
      title: 'আমাদের সুন্দর ক্যাম্পাস',
      subtitle: 'পরিবেশবান্ধব ও আধুনিক সুবিধাসম্পন্ন বিদ্যালয়'
    },
    {
      id: 5,
      src: '/images/slider/5.jpg',
      alt: 'School Image 5',
      title: 'শিক্ষক ও ছাত্রদের সহযোগিতা',
      subtitle: 'সহযোগিতামূলক শিক্ষা পরিবেশ'
    },
    {
      id: 6,
      src: '/images/slider/6.jpg',
      alt: 'School Image 6',
      title: 'ক্রীড়া ও সাংস্কৃতিক কর্মকাণ্ড',
      subtitle: 'শারীরিক ও মানসিক বিকাশে গুরুত্ব'
    },
    {
      id: 7,
      src: '/images/slider/7.jpg',
      alt: 'School Image 7',
      title: 'আমাদের বিদ্যালয়ের ভবিষ্যত',
      subtitle: 'উন্নত শিক্ষা ব্যবস্থার মাধ্যমে উজ্জ্বল ভবিষ্যত গঠন'
    }
  ];

  // Default fallback image if local images are not available
  const defaultImage = 'https://images.unsplash.com/photo-1523050854058-8df90110c9e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80';

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderImages.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [sliderImages.length]);

  // News ticker auto-scroll functionality
  useEffect(() => {
    if (isNewsPaused) return; // Don't auto-scroll if paused
    
    const newsInterval = setInterval(() => {
      setCurrentNewsIndex((prevIndex) => (prevIndex + 1) % newsTicker.length);
    }, 4000); // Change news every 4 seconds

    return () => clearInterval(newsInterval);
  }, [newsTicker.length, isNewsPaused]);

  // Toggle news ticker pause/play
  const toggleNewsPause = () => {
    setIsNewsPaused(!isNewsPaused);
  };

  // Navigation functions
  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const goToPreviousSlide = () => {
    setCurrentSlide((prevSlide) => 
      prevSlide === 0 ? sliderImages.length - 1 : prevSlide - 1
    );
  };

  const goToNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % sliderImages.length);
  };

  return (
    <div className="overflow-x-hidden">
      {/* News Ticker - Fixed under navigation */}
      <div className="fixed top-16 left-0 right-0 bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 text-white z-30 shadow-lg hidden md:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center py-2">
            {/* News Icon */}
            <div className="flex-shrink-0 mr-4">
              <i className="fas fa-newspaper text-lg animate-pulse"></i>
            </div>
            
            {/* Scrolling News Content */}
            <div className="flex-1 overflow-hidden">
              <div className="flex items-center space-x-8 animate-scroll-news">
                {newsTicker.map((news, index) => (
                  <div
                    key={news.id}
                    className={`flex items-center space-x-3 flex-shrink-0 transition-all duration-1000 ${
                      index === currentNewsIndex ? 'opacity-100 scale-105' : 'opacity-60 scale-95'
                    }`}
                  >
                    {/* News Type Badge */}
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      news.priority === 'high' ? 'bg-red-500 text-white' :
                      news.priority === 'medium' ? 'bg-orange-500 text-white' :
                      news.priority === 'info' ? 'bg-blue-500 text-white' :
                      news.priority === 'exam' ? 'bg-purple-500 text-white' :
                      news.priority === 'sports' ? 'bg-green-500 text-white' :
                      news.priority === 'science' ? 'bg-cyan-500 text-white' :
                      'bg-pink-500 text-white'
                    }`}>
                      {news.type}
                    </span>
                    
                    {/* News Text */}
                    <span className="text-sm bangla-font font-medium">
                      {news.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Banner Slider and Notice Section */}
      <section className="py-8 bg-white mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Image Banner Slider - Left Side */}
            <div className="lg:col-span-2">
              <div className="relative bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg overflow-hidden h-64 lg:h-80">
                {/* Slider Images */}
                <div className="relative h-full">
                  <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-all duration-500 ease-in-out" 
                       style={{backgroundImage: `url('${sliderImages[currentSlide]?.src || defaultImage}')`}}>
                  </div>
                  <div className="absolute inset-0 bg-black bg-opacity-40"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-2xl font-bold mb-2 bangla-font">{sliderImages[currentSlide]?.title || 'আমাদের বিদ্যালয়ের সেরা শিক্ষা'}</h3>
                    <p className="text-lg bangla-font">{sliderImages[currentSlide]?.subtitle || 'উচ্চ মানের শিক্ষা ও নৈতিক মূল্যবোধের বিকাশ'}</p>
                  </div>
                </div>
                
                {/* Slider Navigation Dots */}
                <div className="absolute top-4 right-4 flex space-x-2">
                  {sliderImages.map((_, index) => (
                    <button 
                      key={index}
                      onClick={() => goToSlide(index)}
                      className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                        index === currentSlide 
                          ? 'bg-white bg-opacity-100' 
                          : 'bg-white bg-opacity-40 hover:bg-opacity-70'
                      }`}
                    ></button>
                  ))}
                </div>
                
                {/* Slider Arrows */}
                <button 
                  onClick={goToPreviousSlide}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 text-gray-800 p-2 rounded-full transition-all cursor-pointer hover:scale-110"
                >
                  <i className="fas fa-chevron-left"></i>
                </button>
                <button 
                  onClick={goToNextSlide}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 text-gray-800 p-2 rounded-full transition-all cursor-pointer hover:scale-110"
                >
                  <i className="fas fa-chevron-right"></i>
                </button>

                {/* Slide Counter */}
                <div className="absolute bottom-4 right-4 bg-black bg-opacity-50 text-white px-3 py-1 rounded-full text-sm">
                  {currentSlide + 1} / {sliderImages.length}
                </div>
              </div>
            </div>

            {/* Latest Notice Section - Right Side */}
            <div className="lg:col-span-1">
              <div className="bg-blue-50 rounded-lg p-6 h-64 lg:h-80 overflow-y-auto">
                <div className="flex items-center mb-4">
                  <i className="fas fa-bullhorn text-blue-600 text-xl mr-3"></i>
                  <h3 className="text-xl font-bold text-blue-800 bangla-font">সর্বশেষ নোটিশ</h3>
                </div>
                
                <div className="space-y-4">
                  {/* Notice 1 */}
                  <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-red-500">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <i className="fas fa-exclamation-triangle text-red-500 text-lg"></i>
                      </div>
                      <div className="ml-3 flex-1">
                        <h4 className="text-sm font-semibold text-gray-900 bangla-font mb-1">
                          নবম শ্রেণীর রেজিষ্ট্রেশন চলমান
                        </h4>
                        <p className="text-xs text-gray-600 bangla-font mb-2">
                          ভর্তি প্রক্রিয়া শুরু হয়েছে। দ্রুত আবেদন করুন।
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-xs text-red-600 font-medium bangla-font">জরুরী</span>
                          <span className="text-xs text-gray-500">আজ</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Notice 2 */}
                  <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-blue-500">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <i className="fas fa-info-circle text-blue-500 text-lg"></i>
                      </div>
                      <div className="ml-3 flex-1">
                        <h4 className="text-sm font-semibold text-gray-900 bangla-font mb-1">
                          আইডি কার্ড ও স্কুল ড্রেস বাধ্যতামূলক
                        </h4>
                        <p className="text-xs text-gray-600 bangla-font mb-2">
                          সকল শিক্ষার্থীদের জন্য আইডি কার্ড ও স্কুল ড্রেস পরিধান বাধ্যতামূলক।
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-xs text-blue-600 font-medium bangla-font">সাধারণ</span>
                          <span className="text-xs text-gray-500">গতকাল</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Notice 3 */}
                  <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-green-500">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <i className="fas fa-check-circle text-green-500 text-lg"></i>
                      </div>
                      <div className="ml-3 flex-1">
                        <h4 className="text-sm font-semibold text-gray-900 bangla-font mb-1">
                          অনলাইন একাউন্ট খোলার নির্দেশ
                        </h4>
                        <p className="text-xs text-gray-600 bangla-font mb-2">
                          সকল শিক্ষার্থী ও শিক্ষকদের জন্য অনলাইন একাউন্ট খোলা বাধ্যতামূলক।
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-xs text-green-600 font-medium bangla-font">তথ্য</span>
                          <span className="text-xs text-gray-500">২ দিন আগে</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Notice 4 */}
                  <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-yellow-500">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <i className="fas fa-calendar-alt text-yellow-500 text-lg"></i>
                      </div>
                      <div className="ml-3 flex-1">
                        <h4 className="text-sm font-semibold text-gray-900 bangla-font mb-1">
                          বার্ষিক পরীক্ষার সময়সূচী
                        </h4>
                        <p className="text-xs text-gray-600 bangla-font mb-2">
                          বার্ষিক পরীক্ষার সময়সূচী প্রকাশিত হয়েছে। নোটিশ বোর্ডে দেখুন।
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-xs text-yellow-600 font-medium bangla-font">পরীক্ষা</span>
                          <span className="text-xs text-gray-500">৩ দিন আগে</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* View All Button */}
                <div className="mt-4 pt-4 border-t border-blue-200">
                  <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium bangla-font">
                    সকল নোটিশ দেখুন →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* কলেজ সম্পর্কে আরও জানুন Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 bangla-font">
              📚 কলেজ সম্পর্কে আরও জানুন
            </h2>
            <p className="text-gray-600 bangla-font">আমাদের কলেজের বিভিন্ন দিক সম্পর্কে জানুন</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Left Column - Quick Links */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <h2 className="text-2xl font-bold text-gray-900 mb-6 bangla-font text-center">
                  📚 কলেজ সম্পর্কে আরও জানুন
                </h2>
                
                <div className="space-y-3">
                  <button 
                    onClick={() => setSelectedInfo('history')}
                    className={`w-full text-left flex items-center p-3 rounded-lg transition-colors group ${
                      selectedInfo === 'history' 
                        ? 'bg-blue-100 border-l-4 border-blue-500' 
                        : 'bg-blue-50 hover:bg-blue-100'
                    }`}
                  >
                    <span className="text-2xl mr-3">📘</span>
                    <span className={`bangla-font font-medium ${
                      selectedInfo === 'history' ? 'text-blue-700' : 'text-gray-700 group-hover:text-blue-700'
                    }`}>ইতিহাস ও পরিচিতি</span>
                  </button>
                  
                  <button 
                    onClick={() => setSelectedInfo('classes')}
                    className={`w-full text-left flex items-center p-3 rounded-lg transition-colors group ${
                      selectedInfo === 'classes' 
                        ? 'bg-green-100 border-l-4 border-green-500' 
                        : 'bg-green-50 hover:bg-green-100'
                    }`}
                  >
                    <span className="text-2xl mr-3">📚</span>
                    <span className={`bangla-font font-medium ${
                      selectedInfo === 'classes' ? 'text-green-700' : 'text-gray-700 group-hover:text-green-700'
                    }`}>অনুমোদিত ক্লাসসমূহ</span>
                  </button>
                  
                  <button 
                    onClick={() => setSelectedInfo('students')}
                    className={`w-full text-left flex items-center p-3 rounded-lg transition-colors group ${
                      selectedInfo === 'students' 
                        ? 'bg-yellow-100 border-l-4 border-yellow-500' 
                        : 'bg-yellow-50 hover:bg-yellow-100'
                    }`}
                  >
                    <span className="text-2xl mr-3">🎯</span>
                    <span className={`bangla-font font-medium ${
                      selectedInfo === 'students' ? 'text-yellow-700' : 'text-gray-700 group-hover:text-yellow-700'
                    }`}>শিক্ষার্থীদের তথ্য</span>
                  </button>
                  
                  <button 
                    onClick={() => setSelectedInfo('idcard')}
                    className={`w-full text-left flex items-center p-3 rounded-lg transition-colors group ${
                      selectedInfo === 'idcard' 
                        ? 'bg-red-100 border-l-4 border-red-500' 
                        : 'bg-red-50 hover:bg-red-100'
                    }`}
                  >
                    <span className="text-2xl mr-3">🆔</span>
                    <span className={`bangla-font font-medium ${
                      selectedInfo === 'idcard' ? 'text-red-700' : 'text-gray-700 group-hover:text-red-700'
                    }`}>আইডি কার্ড প্রিন্ট</span>
                  </button>
                  
                  <button 
                    onClick={() => setSelectedInfo('results')}
                    className={`w-full text-left flex items-center p-3 rounded-lg transition-colors group ${
                      selectedInfo === 'results' 
                        ? 'bg-indigo-100 border-l-4 border-indigo-500' 
                        : 'bg-indigo-50 hover:bg-indigo-100'
                    }`}
                  >
                    <span className="text-2xl mr-3">🌟</span>
                    <span className={`bangla-font font-medium ${
                      selectedInfo === 'results' ? 'text-indigo-700' : 'text-gray-700 group-hover:text-indigo-700'
                    }`}>এস.এস.সি. ফলাফল</span>
                  </button>
                  
                  <button 
                    onClick={() => setSelectedInfo('principal')}
                    className={`w-full text-left flex items-center p-3 rounded-lg transition-colors group ${
                      selectedInfo === 'principal' 
                        ? 'bg-pink-100 border-l-4 border-pink-500' 
                        : 'bg-pink-50 hover:bg-pink-100'
                    }`}
                  >
                    <span className="text-2xl mr-3">🗨️</span>
                    <span className={`bangla-font font-medium ${
                      selectedInfo === 'principal' ? 'text-pink-700' : 'text-gray-700 group-hover:text-pink-700'
                    }`}>প্রতিষ্ঠান প্রধানের বাণী</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Right Column - College Information */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-lg p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 bangla-font">
                  {collegeInfo[selectedInfo]?.title}
                </h3>
                
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 mb-6 leading-relaxed bangla-font">
                    {collegeInfo[selectedInfo]?.content}
                  </p>
                  
                  {/* Additional Information Grid */}
                  {collegeInfo[selectedInfo]?.additionalInfo && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                      {collegeInfo[selectedInfo]?.additionalInfo.map((info, index) => (
                        <div key={index} className={`bg-${info.color}-50 p-4 rounded-lg border-l-4 border-${info.color}-400`}>
                          <h3 className={`text-lg font-semibold text-${info.color}-800 mb-2 bangla-font`}>
                            🌟 {info.type}
                          </h3>
                          <p className="text-gray-700 bangla-font mb-3">{info.content}</p>
                          {info.hasButton && (
                            <button className={`bg-${info.color}-600 text-white px-4 py-2 rounded-lg hover:bg-${info.color}-700 transition-colors text-sm bangla-font`}>
                              ডাউনলোড করুন
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6 rounded-lg bg-blue-50">
              <i className="fas fa-graduation-cap text-4xl text-blue-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-2 bangla-font">{content.home.features.academic}</h3>
            </div>
            <div className="text-center p-6 rounded-lg bg-green-50">
              <i className="fas fa-landmark text-4xl text-green-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-2 bangla-font">{content.home.features.cultural}</h3>
            </div>
            <div className="text-center p-6 rounded-lg bg-purple-50">
              <i className="fas fa-laptop text-4xl text-purple-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-2 bangla-font">{content.home.features.technology}</h3>
            </div>
            <div className="text-center p-6 rounded-lg bg-orange-50">
              <i className="fas fa-futbol text-4xl text-orange-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-2 bangla-font">{content.home.features.sports}</h3>
            </div>
          </div>
        </div>
      </section>

      {/* শিক্ষার্থী কর্নার Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Student Services Title */}
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 bangla-font">
              🎓 শিক্ষার্থী কর্নার
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-4xl mx-auto">
              <div className="text-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <span className="text-3xl block mb-2">🔐</span>
                <span className="bangla-font font-medium text-gray-700">লগইন</span>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <span className="text-3xl block mb-2">📝</span>
                <span className="bangla-font font-medium text-gray-700">ভর্তি</span>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <span className="text-3xl block mb-2">💳</span>
                <span className="bangla-font font-medium text-gray-700">পেমেন্ট চেক</span>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <span className="text-3xl block mb-2">✅</span>
                <span className="bangla-font font-medium text-gray-700">আজকের উপস্থিতি</span>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <span className="text-3xl block mb-2">💻</span>
                <span className="bangla-font font-medium text-gray-700">অনলাইন ক্লাস</span>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
                <span className="text-3xl block mb-2">💰</span>
                <span className="bangla-font font-medium text-gray-700">বেতন</span>
              </div>
            </div>
          </div>

          {/* Class Routine - Full Width */}
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 bangla-font text-center">
              📅 ২০২৫ সালের ক্লাস রুটিন
            </h3>
            
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-blue-50">
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">বার</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">শ্রেণি</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">সমাবেশ</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">১ম সেশন</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">২য় সেশন</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">৩য় সেশন</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">৪র্থ সেশন</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">বিরতি</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">৫ম সেশন</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">৬ষ্ঠ সেশন</th>
                    <th className="border border-gray-300 p-3 text-sm font-semibold text-gray-700 bangla-font">৭ম সেশন</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-gray-50">
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center" rowSpan={5}>রবিবার থেকে বৃহস্পতিবার</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">সময়</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">৯:৪৫-১০:০০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">১০:০০-১০:৫০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">১০:৫০-১১:৪০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">১১:৪০-১২:৩০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">১২:৩০-০১:২০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">০১:২০-০২:০০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">০২:০০-০২:৪০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">০২:৪০-০৩:২০</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-600 bangla-font text-center">০৩:২০-০৪:০০</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">৬ষ্ঠ</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">স<br/>মা<br/>বে<br/>শ</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গণিত (2-5)<br/>G.K</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইংরেজী ২য়()<br/>K.B</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বিজ্ঞান (4</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বাংলা ১ম<br/>M.R</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বাংলা ও বিশ্ব<br/>G.M</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইংরেজী ১ম<br/>S.P</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বিজ্ঞান<br/>S.R</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গণিত<br/>G.K</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">৭ম</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">স<br/>মা<br/>বে<br/>শ</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বাংলা ১ম<br/>M.R</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গণিত<br/>G.M</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বিজ্ঞান<br/>S.R</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বিজ্ঞান<br/>MI</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইসলাম/কৃষি<br/>AK</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইংরেজী ১ম/২য়<br/>T.F</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">কৃষি/তথ্য<br/>DM</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">৮ম</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">স<br/>মা<br/>বে<br/>শ</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বিজ্ঞান<br/>AR</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইসলাম/হিন্দু ধর্ম<br/>AK/SR</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বাংলা ১ম/২য়<br/>AM</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গণিত<br/>MR</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইংরেজী ১ম/২য়<br/>T.F</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইতিহাস<br/>DM</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">কৃষি/তথ্য<br/>MR</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">৯ম</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">স<br/>মা<br/>বে<br/>শ</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বিজ্ঞান<br/>MI</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গণিত<br/>MR</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইংরেজি ১ম/২য়<br/>T.F</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বাংলা ১ম/২য়<br/>AM</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গ্রুপ<br/>AR/SI</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">কৃষি/তথ্য<br/>SR</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইসলাম/হিন্দু ধর্ম<br/>AK</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">১০ম</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">স<br/>মা<br/>বে<br/>শ</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গণিত<br/>MR</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইংরেজি ১ম/২য়<br/>T.F</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বিজ্ঞান<br/>MI</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">গ্রুপ<br/>AR/DM</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">বাংলা ১ম/২য়<br/>AM</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">ইসলাম/হিন্দু ধর্ম<br/>AK/AR</td>
                    <td className="border border-gray-300 p-2 text-xs text-gray-700 bangla-font text-center">কৃষি/তথ্য<br/>MI</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-blue-600 mb-2">১০০০+</div>
              <div className="text-gray-600 bangla-font">{content.home.stats.students}</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-green-600 mb-2">৫০+</div>
              <div className="text-gray-600 mb-2 bangla-font">{content.home.stats.years}</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-purple-600 mb-2">২৫+</div>
              <div className="text-gray-600 mb-2 bangla-font">{content.home.stats.years}</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-orange-600 mb-2">৬</div>
              <div className="text-gray-600 bangla-font">ভবন</div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section - আমাদের দল */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 bangla-font">আমাদের দল</h2>
            <p className="text-gray-600 bangla-font">আমাদের অভিজ্ঞ ও দক্ষ শিক্ষকমণ্ডলী এবং প্রশাসনিক কর্মকর্তাদের সাথে পরিচিত হোন</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Director */}
            <div className="text-center">
              <div className="relative mb-4">
                <div className="w-32 h-32 mx-auto bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-4xl font-bold shadow-lg">
                  <i className="fas fa-user-tie"></i>
                </div>
                <div className="absolute -bottom-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                  পরিচালক
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1 bangla-font">মোঃ আব্দুল হামিদ</h3>
              <p className="text-sm text-gray-600 bangla-font">পরিচালক</p>
              <p className="text-xs text-gray-500 bangla-font">এম.এ, বিএড</p>
            </div>

            {/* Principal */}
            <div className="text-center">
              <div className="relative mb-4">
                <div className="w-32 h-32 mx-auto bg-gradient-to-br from-green-500 to-blue-600 rounded-full flex items-center justify-center text-white text-4xl font-bold shadow-lg">
                  <i className="fas fa-user-graduate"></i>
                </div>
                <div className="absolute -bottom-2 -right-2 bg-blue-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                  প্রধান শিক্ষক
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1 bangla-font">মোঃ রফিকুল ইসলাম</h3>
              <p className="text-sm text-gray-600 bangla-font">প্রধান শিক্ষক</p>
              <p className="text-xs text-gray-500 bangla-font">এম.এ, বিএড</p>
            </div>

            {/* Vice Principal */}
            <div className="text-center">
              <div className="relative mb-4">
                <div className="w-32 h-32 mx-auto bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center text-white text-4xl font-bold shadow-lg">
                  <i className="fas fa-user-graduate"></i>
                </div>
                <div className="absolute -bottom-2 -right-2 bg-purple-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                  সহকারী প্রধান শিক্ষক
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1 bangla-font">মোঃ সেলিম আহমেদ</h3>
              <p className="text-sm text-gray-600 bangla-font">সহকারী প্রধান শিক্ষক</p>
              <p className="text-xs text-gray-500 bangla-font">এম.এ, বিএড</p>
            </div>

            {/* Senior Teacher */}
            <div className="text-center">
              <div className="relative mb-4">
                <div className="w-32 h-32 mx-auto bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white text-4xl font-bold shadow-lg">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <div className="absolute -bottom-2 -right-2 bg-orange-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                  সিনিয়র শিক্ষক
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1 bangla-font">মোঃ জাহাঙ্গীর আলম</h3>
              <p className="text-sm text-gray-600 bangla-font">সিনিয়র শিক্ষক</p>
              <p className="text-xs text-gray-500 bangla-font">এম.এ, বিএড</p>
            </div>
          </div>

          {/* More Teachers Grid */}
          <div className="mt-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center bangla-font">আমাদের শিক্ষকমণ্ডলী</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
              {/* Teacher 1 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-blue-400 to-cyan-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ কামরুল হাসান</h4>
                <p className="text-xs text-gray-600 bangla-font">বাংলা</p>
              </div>

              {/* Teacher 2 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ রাশেদুল ইসলাম</h4>
                <p className="text-xs text-gray-600 bangla-font">ইংরেজি</p>
              </div>

              {/* Teacher 3 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-purple-400 to-violet-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ সোহেল রানা</h4>
                <p className="text-xs text-gray-600 bangla-font">গণিত</p>
              </div>

              {/* Teacher 4 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-orange-400 to-amber-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ নজরুল ইসলাম</h4>
                <p className="text-xs text-gray-600 bangla-font">বিজ্ঞান</p>
              </div>

              {/* Teacher 5 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-red-400 to-pink-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ মিজানুর রহমান</h4>
                <p className="text-xs text-gray-600 bangla-font">ইসলাম শিক্ষা</p>
              </div>

              {/* Teacher 6 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-indigo-400 to-blue-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ শফিকুল ইসলাম</h4>
                <p className="text-xs text-gray-600 bangla-font">কৃষি শিক্ষা</p>
              </div>

              {/* Teacher 7 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-teal-400 to-cyan-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ রফিক আহমেদ</h4>
                <p className="text-xs text-gray-600 bangla-font">তথ্য ও যোগাযোগ প্রযুক্তি</p>
              </div>

              {/* Teacher 8 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-lime-400 to-green-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ জাহিদুল ইসলাম</h4>
                <p className="text-xs text-gray-600 bangla-font">শারীরিক শিক্ষা</p>
              </div>

              {/* Teacher 9 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ সাইফুল ইসলাম</h4>
                <p className="text-xs text-gray-600 bangla-font">চারু ও কারুকলা</p>
              </div>

              {/* Teacher 10 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-pink-400 to-rose-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ রিয়াজুল ইসলাম</h4>
                <p className="text-xs text-gray-600 bangla-font">গার্হস্থ্য বিজ্ঞান</p>
              </div>

              {/* Teacher 11 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-violet-400 to-purple-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ তৌফিক আহমেদ</h4>
                <p className="text-xs text-gray-600 bangla-font">বাংলাদেশ ও বিশ্বপরিচয়</p>
              </div>

              {/* Teacher 12 */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
                  <i className="fas fa-chalkboard-teacher"></i>
                </div>
                <h4 className="text-sm font-medium text-gray-900 mb-1 bangla-font">মোঃ সাবরিনা আক্তার</h4>
                <p className="text-xs text-gray-600 bangla-font">সহকারী শিক্ষিকা</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notice Board Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 bangla-font">নোটিশ বোর্ড</h2>
            <p className="text-gray-600 bangla-font">আমাদের সর্বশেষ ঘোষণা এবং গুরুত্বপূর্ণ তথ্য জানতে নিয়মিত অনুসরণ করুন</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Latest Notices */}
            <div className="bg-blue-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold text-blue-800 mb-4 bangla-font">সর্বশেষ নোটিশ</h3>
              <div className="space-y-3">
                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                  <i className="fas fa-exclamation-triangle text-red-500 text-lg"></i>
                  <div>
                    <p className="font-medium text-gray-900 bangla-font mb-1">
                      নবম শ্রেণীর রেজিষ্ট্রেশন চলমান
                    </p>
                    <p className="text-xs text-gray-500 bangla-font mb-2">
                      ভর্তি প্রক্রিয়া শুরু হয়েছে। দ্রুত আবেদন করুন।
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-red-600 font-medium bangla-font">জরুরী</span>
                      <span className="text-xs text-gray-500">আজ</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                  <i className="fas fa-calendar text-green-600 text-lg"></i>
                  <div>
                    <p className="font-medium text-gray-900 bangla-font mb-1">
                      এইচএসসি পরীক্ষা ২০২৫ সংশোধিত সময়সূচী
                    </p>
                    <p className="text-xs text-gray-500 bangla-font mb-2">
                      এইচএসসি পরীক্ষার সময়সূচী প্রকাশিত হয়েছে। নোটিশ বোর্ডে দেখুন।
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-green-600 font-medium bangla-font">পরীক্ষা</span>
                      <span className="text-xs text-gray-500">গতকাল</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                  <i className="fas fa-chart-line text-purple-600 text-lg"></i>
                  <div>
                    <p className="font-medium text-gray-900 bangla-font mb-1">
                      বিজ্ঞান সেন্ট-আপ-১ ফলাফল ২০২৫
                    </p>
                    <p className="text-xs text-gray-500 bangla-font mb-2">
                      বিজ্ঞান সেন্ট-আপ-১ ফলাফল প্রকাশিত হয়েছে। নোটিশ বোর্ডে দেখুন।
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-purple-600 font-medium bangla-font">ফলাফল</span>
                      <span className="text-xs text-gray-500">২ দিন আগে</span>
                    </div>
                  </div>
                </div>
              </div>
              <button className="w-full mt-4 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors bangla-font">
                সকল নোটিশ দেখুন →
              </button>
            </div>

            {/* Upcoming Events */}
            <div className="bg-green-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold text-green-800 mb-4 bangla-font">আসন্ন অনুষ্ঠান</h3>
              <div className="space-y-3">
                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                  <i className="fas fa-trophy text-yellow-600 text-lg"></i>
                  <div>
                    <p className="font-medium text-gray-900 bangla-font mb-1">
                      বার্ষিক ক্রীড়া দিবস ২০২৫
                    </p>
                    <p className="text-xs text-gray-500 bangla-font mb-2">
                      ১৫ ডিসেম্বর, ২০২৫ তারিখে বার্ষিক ক্রীড়া দিবস উদযাপিত হবে।
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-yellow-600 font-medium bangla-font">ক্রীড়া</span>
                      <span className="text-xs text-gray-500">৩ দিন আগে</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                  <i className="fas fa-flask text-blue-600 text-lg"></i>
                  <div>
                    <p className="font-medium text-gray-900 bangla-font mb-1">
                      বিজ্ঞান মেলা ২০২৫
                    </p>
                    <p className="text-xs text-gray-500 bangla-font mb-2">
                      ২০ নভেম্বর, ২০২৫ তারিখে বিজ্ঞান মেলা অনুষ্ঠিত হবে। সকল শিক্ষার্থী অংশগ্রহণ করবে।
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-blue-600 font-medium bangla-font">বিজ্ঞান</span>
                      <span className="text-xs text-gray-500">১ সপ্তাহ আগে</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center p-3 bg-white rounded-lg shadow-sm">
                  <i className="fas fa-flag text-red-600 text-lg"></i>
                  <div>
                    <p className="font-medium text-gray-900 bangla-font mb-1">
                      স্বাধীনতা দিবস উদযাপন
                    </p>
                    <p className="text-xs text-gray-500 bangla-font mb-2">
                      ২৬ মার্চ, ২০২৫ তারিখে স্বাধীনতা দিবস উদযাপিত হবে। বিশেষ অনুষ্ঠানের আয়োজন করা হয়েছে।
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-red-600 font-medium bangla-font">জাতীয়</span>
                      <span className="text-xs text-gray-500">২ সপ্তাহ আগে</span>
                    </div>
                  </div>
                </div>
              </div>
              <button className="w-full mt-4 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors bangla-font">
                সকল অনুষ্ঠান দেখুন →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Published Sections - প্রকাশিত বিভাগসমূহ */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4 bangla-font">প্রকাশিত বিভাগসমূহ</h2>
            <p className="text-gray-600 bangla-font">কোন বিভাগে ক্লিক করে পোস্ট দেখুন</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            <button className="text-center p-3 bg-purple-50 rounded-lg hover:bg-purple-100 transition-colors hover:shadow-md">
              <i className="fas fa-star text-purple-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">আদর্শ ও নীতি</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors hover:shadow-md">
              <i className="fas fa-graduation-cap text-blue-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">একাডেমিক সেন্টার</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-green-50 rounded-lg hover:bg-green-100 transition-colors hover:shadow-md">
              <i className="fas fa-book-open text-green-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">এসএসসি অনুশীলন</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-yellow-50 rounded-lg hover:bg-yellow-100 transition-colors hover:shadow-md">
              <i className="fas fa-clipboard-check text-yellow-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">এসএসসি পরীক্ষার প্রস্তুতি</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-red-50 rounded-lg hover:bg-red-100 transition-colors hover:shadow-md">
              <i className="fas fa-futbol text-red-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">খেলাধূলা</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-indigo-50 rounded-lg hover:bg-indigo-100 transition-colors hover:shadow-md">
              <i className="fas fa-calendar-alt text-indigo-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">জুলাই কর্ণার</p>
              <p className="text-xs text-gray-500 bangla-font">১ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-pink-50 rounded-lg hover:bg-pink-100 transition-colors hover:shadow-md">
              <i className="fas fa-broom text-pink-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">পরিষ্কার পরিচ্ছন্নতা</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors hover:shadow-md">
              <i className="fas fa-users text-orange-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">পিতা মাতা</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-teal-50 rounded-lg hover:bg-teal-100 transition-colors hover:shadow-md">
              <i className="fas fa-flask text-teal-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">বিজ্ঞান কর্ণার</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-cyan-50 rounded-lg hover:bg-cyan-100 transition-colors hover:shadow-md">
              <i className="fas fa-lightbulb text-cyan-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">রাষ্ট্র চিন্তা</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-lime-50 rounded-lg hover:bg-lime-100 transition-colors hover:shadow-md">
              <i className="fas fa-archive text-lime-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">রিসোর্স সেন্টার</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
            <button className="text-center p-3 bg-amber-50 rounded-lg hover:bg-amber-100 transition-colors hover:shadow-md">
              <i className="fas fa-chalkboard-teacher text-amber-600 text-xl mb-2"></i>
              <p className="text-sm font-medium bangla-font">শিক্ষক ও ছাত্র</p>
              <p className="text-xs text-gray-500 bangla-font">০ টি পোস্ট</p>
            </button>
          </div>
        </div>
      </section>

      {/* Admission Call-to-Action Section - ভর্তি চলছে! */}
      <section className="py-16 bg-gradient-to-r from-green-600 to-green-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6 bangla-font">ভর্তি চলছে! এখনই যোগাযোগ করুন</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto bangla-font">
            আপনার সন্তানের উজ্জ্বল ভবিষ্যতের জন্য সঠিক সিদ্ধান্ত নিন আজই।
          </p>
          <button className="bg-white text-green-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors shadow-lg bangla-font">
            📞 যোগাযোগ করুন
          </button>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
